module.exports = __webpack_public_path__ + "img/recom_bg_3.01592ebc.png";